import styled from 'styled-components';
import MEDIA from 'helpers/mediaTemplates';

export const Text = styled.span`
  display: block;
  margin-bottom: 1rem;
  font-weight: ${({ size }) => () => {
    switch (size) {
      case 'large':
        return '500';
      default:
        return '500';
    }
  }};
  font-size: ${({ size }) => () => {
    switch (size) {
      case 'large':
        return '2rem';
      default:
        return '2rem';
    }
  }};
  line-height: 1.0;
  //color: #C00000 ;
  //color: #FFFFFF;
  ${MEDIA.TABLET`
    font-size: ${({ size }) => () => {
      switch (size) {
        case 'large':
          return '1.6rem';
        default:
          return '1rem';
      }
    }};
  `};
`;
